"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _formValidations = require("../../helpers/formValidations");
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _APCryptoAddressInputContainer = _interopRequireDefault(require("../common/APCryptoAddressInput/APCryptoAddressInputContainer"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
require("./WhiteListAddressForm.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('whitelist-address-form');
var WhiteListAddressForm = function WhiteListAddressForm(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var invalid = props.invalid,
    submitting = props.submitting,
    ProductSymbol = props.ProductSymbol,
    handleSubmit = props.handleSubmit;
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('label-text'),
    style: {
      marginBottom: '1.4rem'
    }
  }, t("Add an address to the whitelist")), /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('label-text')
  }, t("Name")), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    name: "Name",
    label: "Name",
    customClass: (0, _cssClassesHelper.getBEMClasses)('send-form')(),
    validate: [_formValidations.required]
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('label-text')
  }, t("Address")), /*#__PURE__*/_react["default"].createElement(_APCryptoAddressInputContainer["default"], {
    productSymbol: ProductSymbol,
    name: "AccountIdentifier",
    customClass: (0, _cssClassesHelper.getBEMClasses)('send-form')(),
    label: "Address"
  }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    customClass: (0, _cssClassesHelper.getBEMClasses)('send-form')(),
    styleName: "additive",
    disabled: invalid || submitting
  }, t("Add to Whitelist")));
};
var _default = exports["default"] = WhiteListAddressForm;